// extracted by mini-css-extract-plugin
export var cardContainer = "_or-0";
export var cardHeader = "_or-2";
export var collapsedState = "_or-3";
export var dragHandle = "_or-5";
export var dragHandleIcon = "_or-6";
export var dragging = "_or-1";
export var titleArea = "_or-4";